export const SET_DELIVERY_HOME_KEYWORD = 'SET_DELIVERY_HOME_KEYWORD' as const
export const GET_DELIVERY_RESTAURANTS = 'GET_DELIVERY_RESTAURANTS' as const
export const GET_DELIVERY_RESTAURANTS_SUCCEEDED = 'GET_DELIVERY_RESTAURANTS_SUCCEEDED' as const

export const GET_DELIVERY_NEXT_RESTAURANTS = 'GET_DELIVERY_NEXT_RESTAURANTS' as const
export const GET_DELIVERY_NEXT_RESTAURANTS_SUCCEEDED = 'GET_DELIVERY_NEXT_RESTAURANTS_SUCCEEDED' as const
